export default __webpack_public_path__ + "static/media/4-3-completionOfME.1dfbb95b.png";